import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

/** Admin: fetch group_trips, shared_rentals, private_tours needing-action counts for sidebar badges. */
export function getActionCounts() {
  return axios({ method: 'get', url: `${API_URL}/admin/action_counts` });
}

/** Admin: total vendor-owned listings pending approval (sidebar "All Vendors" badge). */
export function getListingsPendingCount() {
  return axios({ method: 'get', url: `${API_URL}/admin/listings_pending_count` });
}

/** Admin: vendor's listing counts and summary for detail page. */
export function getVendorListingsSummary(vendorId) {
  return axios({ method: 'get', url: `${API_URL}/admin/vendors/${vendorId}/listings_summary` });
}

/** Admin: get platform settings (pricing defaults, USD to NPR rate). */
export function getPlatformSettings() {
  return axios({ method: 'get', url: `${API_URL}/admin/platform_settings` });
}

/** Admin: update platform settings (pricing defaults, USD to NPR rate). */
export function updatePlatformSettings(data) {
  return axios({ method: 'patch', url: `${API_URL}/admin/platform_settings`, data });
}
